<template>
  <table>
    <thead>
    <tr>
      <th></th>
      <th v-for="(date, dateIndex) in dateWindow" v-bind:key="dateIndex" v-bind:class="[date.dateLabel.includes('ma')? 'monday' : '', date.dateLabel == toDay ? 'today' : 'not-today']">
        <span v-bind:class="['tag']" @click="reloadDate(date.date)">{{ date.dateLabel }}</span>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(user, userIndex) in activeUsers" v-bind:key="userIndex">
      <th><div>{{ user.name }}</div></th>
      <td v-for="(date, dateIndex) in dateWindow" v-bind:key="dateIndex" v-bind:class="[date.dateLabel.includes('ma')? 'monday' : '', date.dateLabel == toDay ? 'today' : 'not-today']">
        <CalendarItem :schedule="schedule.get(date.dateLabel)?.get(user.email)" />
      </td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <th></th>
      <th v-for="(date, dateIndex) in dateWindow" v-bind:key="dateIndex" v-bind:class="[date.dateLabel.includes('ma')? 'monday' : '', date.dateLabel == toDay ? 'today' : 'not-today']">
        <span v-bind:class="['tag']" @click="reloadDate(date.date)">{{ date.dateLabel }}</span>
      </th>
    </tr>
    </tfoot>
  </table>
</template>

<script>
import {mapGetters} from 'vuex'
import CalendarItem from "./CalendarItem";

export default {
  components: {
    CalendarItem
  },
  data() {
    return {
      today: new Date()
    }
  },
  computed: {
    ...mapGetters([
      'users',
      'activeGroup',
      'schedule',
      'search'
    ]),
    dateWindow() {
      return this.$store.getters.dateWindow.map(
          (date) => {
            return {
              dateLabel: date.toLocaleDateString(
                  'nl-NL',
                  {weekday: 'short', month: 'numeric', day: 'numeric'}
              ),
              date: date
            }
          }
      )
    },
    toDay() {
      return this.today.toLocaleDateString(
            'nl-NL',
            {weekday: 'short', month: 'numeric', day: 'numeric'}
        )
    },
    activeUsers() {
      let users = this.users
      if (this.activeGroup) {
        let groupMails = this.activeGroup.members.map((member) => member.mail)
        users = users.filter((user) => groupMails.includes(user.email))
      }
      if (this.search) {
        users = users.filter((user) => user.name.toLowerCase().includes(this.search.toLowerCase()))
      }
      return users
    }
  },
  methods: {
    reloadDate(date) {
      this.$store.dispatch('loadScheduleForDate', date, true)
    }
  }
}
</script>

<style scoped>

</style>

